import React, { CSSProperties, useRef } from 'react';

import { useConnectorDrag } from './useConnectorDrag';
import { useConnectorRegister } from './useConnectorRegister';

import { Connector, ConnectorProps } from './Connector';

import { connectorTypesMap } from './connectorTypes';

export type ExecutionState = { type: string; [key: string]: any };

export interface ConnectorErrorProps
  extends Omit<
    ConnectorProps,
    | 'connectorTypeColorOverride'
    | 'isSiblingActive'
    | 'isConnectorDone'
    | 'isDraggingAndCanConnect'
    | 'children'
  > {
  nodeId: string;
  cardRootRef: React.RefObject<HTMLElement>;
  activeConnectors: Set<string>;
  executionState: ExecutionState;
  style?: CSSProperties;
}

export function ConnectorError(props: ConnectorErrorProps) {
  const circleRef = useRef<SVGCircleElement | null>(null);
  const connectorErrorRef = useRef<HTMLDivElement | null>(null);

  const collectedProps = useConnectorDrag({
    ref: connectorErrorRef,
    type: connectorTypesMap.Error,
    nodeId: props.nodeId,
    isDisabled: props.isDisabled,
  });

  useConnectorRegister({
    cardRootRef: props.cardRootRef,
    centerRef: circleRef,
    type: connectorTypesMap.Error,
    nodeId: props.nodeId,
    centerRefs: null,
  });

  const isActive = props.activeConnectors.has(`${props.nodeId}::${connectorTypesMap.Error}`);

  return (
    <Connector
      circleRef={circleRef}
      dragHandleRef={connectorErrorRef}
      positionStyle={props.style}
      connectorType={connectorTypesMap.Error}
      executionState={props.executionState}
      isActive={isActive}
      isHovered={props.isHovered}
      isSelected={props.isSelected}
      isDisabled={props.isDisabled}
      isDisabledStyle={props.isDisabledStyle}
      isVisibleOverride={props.isVisibleOverride}
      isDragging={collectedProps?.isDragging}
      isDragOverAndCanConnect={props.isDragOverAndCanConnect}
      direction={props.direction}
    />
  );
}
